import { useLocalStorageJSONValue } from '@hotjar/insights-common/index';
import { useCurrentUser } from '@hotjar/user';
import { useUserExperiment } from '@hotjar/webapp/hooks/useExperiment';

export const useMergedSurveyViewExperiment = (): boolean => {
  const [localOverride] = useLocalStorageJSONValue<boolean>(
    'HJ_OVERRIDE_EXP:ran__merge_responses_with_results',
  );
  const { data: user } = useCurrentUser();
  const { inVariant1: isInMergedViewExperiment } = useUserExperiment(
    'ran__merge_responses_with_results',
    user,
  );

  return localOverride === true || isInMergedViewExperiment;
};
